import { useRef } from 'react'
import { useEffect } from 'react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

type NavigationDate = {
  startDate: Date
  endDate: Date
} | null

export const useTrackDateFilterChange = (date: NavigationDate) => {
  const startDate = date?.startDate.toISOString() ?? ''
  const endDate = date?.endDate.toISOString() ?? ''

  const periodDateInitialized = useRef(false)
  useEffect(() => {
    if (periodDateInitialized.current) {
      track(trackingEvents.expenses.filter, {
        origin: 'expenses_reports',
        filter_by: 'date',
      })
    }

    if (startDate != '' && endDate != '') {
      periodDateInitialized.current = true
    }
  }, [startDate, endDate])
}
